import * as $ from 'jquery';
import { onClick }     from 'Core/Events';

/**
 * @description Komponent wiszącego przycisku znajdującego się w prawym dolnym rogu (zarówno Desktop jak i mobile).
 * Po kliknięciu w niego strona uzytkownika przescrolluje sie plynnie na sama gore 
 */
export const ScrollUpBtn = (() => {

    const BTN = '.scroll-up-btn';

    onClick(BTN, scrollPageToTop);

    $(window).on('scroll', ( () => {
        const $height = $(window).scrollTop();
        if ($height >  70) {
            $(BTN).show("fast");
        } else {
            $(BTN).hide("fast");
        }
    }))

    function scrollPageToTop(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

})();import * as $ from 'jquery';
import { onClick }     from 'Core/Events';

/**
 * @description Komponent wiszącego przycisku znajdującego się w prawym dolnym rogu (zarówno Desktop jak i mobile).
 * Po kliknięciu w niego strona uzytkownika przescrolluje sie plynnie na sama gore 
 */
export const ScrollUpBtn = (() => {

    const BTN = '.scroll-up-btn';

    onClick(BTN, scrollPageToTop);

    $(window).on('scroll', ( () => {
        const $height = $(window).scrollTop();
        if ($height >  70) {
            $(BTN).show("fast");
        } else {
            $(BTN).hide("fast");
        }
    }))

    function scrollPageToTop(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

})();